import script from "./BaseModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseModal.vue?vue&type=script&lang=ts&setup=true"

import "./BaseModal.vue?vue&type=style&index=0&id=4961c3eb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4961c3eb"]])

export default __exports__